import {SuggestionPrimitive, useAuiState} from '@assistant-ui/react';
import {type AutoColor, CalloutIcon, type IconName} from '@wandb/components';
import React from 'react';

import {useTrackWBAgentComposer} from './useTrackWBAgent';

type WBAgentSuggestionItem = {
  icon: IconName;
  color: AutoColor;
  title: string;
  label: string;
  prompt: string;
};
export const SUGGESTION_ITEMS: WBAgentSuggestionItem[] = [
  {
    icon: 'report',
    color: 'teal',
    title: 'Summarize this project in a report',
    label: '',
    prompt: 'Summarize this project in a report',
  },
  {
    icon: 'lightbulb-info',
    color: 'blue',
    title: 'Recommend my next experiment',
    label: '',
    prompt: 'Recommend my next experiment',
  },
  {
    icon: 'chart-line',
    color: 'gold',
    title: 'What patterns do you see in my results?',
    label: '',
    prompt: 'What patterns do you see in my results?',
  },
  {
    icon: 'dashboard-blackboard',
    color: 'green',
    title: 'What can you do?',
    label: '',
    prompt: 'What can you do?',
  },
];

export const SuggestionItem = () => {
  const {trackSuggestionClicked, trackMessageSent} = useTrackWBAgentComposer();

  const title = useAuiState(s => s.suggestion.title);
  const meta = SUGGESTION_ITEMS.find(i => i.title === title);
  if (!meta) {
    return null;
  }
  return (
    <SuggestionPrimitive.Trigger
      send
      onClick={() => {
        trackSuggestionClicked(meta.title);
        trackMessageSent('suggestion');
      }}
      className="flex min-w-0 pr-16 pl-12 py-6 items-center gap-8 rounded-lg border border-moon-250 shadow-flat hover:bg-moon-100 disabled:cursor-not-allowed disabled:opacity-50">
      <CalloutIcon icon={meta.icon} color={meta.color} size="sm" />
      <SuggestionPrimitive.Title className="min-w-0 flex-1 text-left text-moon-800 truncate font-medium text-sm leading-[22.4px]" />
    </SuggestionPrimitive.Trigger>
  );
};
